import { render, staticRenderFns } from "./CompactCurrency.vue?vue&type=template&id=7071df7c&"
import script from "./CompactCurrency.vue?vue&type=script&lang=js&"
export * from "./CompactCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports